import React, { useEffect, useState } from "react";
import axios from "axios";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
//import SidebarLeft from "../SidebarLeft";
//import SidebarRight from "../SidebarRight";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import {  momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
//import moment from "moment";
import "./Conferences.css";
import SecondaryMenu from "../SecondaryMenu";

import { Link } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";
//moment.locale("it"); // Imposta la localizzazione su italiano
//const localizer = momentLocalizer(moment);

function TrainingSchools() {
  const [selectedYear, setSelectedYear] = useState(new Date());
  const [content, setContent] = useState(null);
  /*
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  */

  const handleYearChange = (date) => {
    setSelectedYear(date);
  };

  useEffect(() => {
    const year = selectedYear.getFullYear();
    axios
      .post(`${serverConfig.serverUrl}/get_training_schools`, {
        year: year,
      })
      .then((response) => {
        const data = response.data;
        setContent(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_training_schools");
        //console.log("PAGINA INIZIALE | get_training_schools | error", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, [selectedYear]);

  /*
  const renderImages = (imageItems) => {
    let colClass = "col-12";
    return (
      <div className="image-list row">
        {imageItems.map((item, index) => {
          // Modifica l'URL per puntare al nuovo endpoint /images
          const imageUrl = `${serverConfig.serverUrl}/images/${item.img}`;
          return (
            <>
            <div>
            {item.img}
            </div>
            <div>
            imageUrl: {imageUrl}
            </div>
            <div key={index} className={`image-wrapper ${colClass}`}>
              <a href={item.link}>
                <img src={imageUrl} alt={item.title} />
              </a>
              <div className="image-info">
                <h5 style={{ color: "blue" }}>{item.title}</h5>
                <p dangerouslySetInnerHTML={{ __html: item.info_school }} />
                <p dangerouslySetInnerHTML={{ __html: item.info_year }} />
              </div>
            </div>
            </>
          );
        })}
      </div>
    );
  };
  */

  /*

      <>
        <div className="conference-items" style={{ marginBottom: "5px" }}>
          <div className="conference-item">
            <div className="conference-img-large">
              <div>{circleImg(img)}</div>
            </div>
            <div className="conference-item-content">
  */

  /*
  const renderImages = (imageItems) => {
    return (
      <div className="conference-items" style={{ marginBottom: "5px" }}>
        {imageItems.map((item, index) => {
          const src = `${serverConfig.serverUrl}/img/training_schools/${item.img}`;
          return (
            <>
              <div className="conference-item">
                <div className="conference-img-large">
                  <a href={item.link}>
                    <img
                      src={src}
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "block",
                        backgroundColor: "transparent", // Imposta lo sfondo trasparente per mostrare il bianco dietro in caso di errore
                        borderRadius: "5%",
                      }}
                    />
                  </a>
                </div>
                <div className="conference-item-content">
                  <a href={item.link}>
                    <strong>{item.title}</strong>
                  </a>
                  <p dangerouslySetInnerHTML={{ __html: item.info_school }} />
                  <p dangerouslySetInnerHTML={{ __html: item.info_year }} />
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  };
  */

  const renderImages = (items) => {
    // Divide gli elementi in coppie per visualizzarli in due colonne per riga
    const pairs = [];
    for (let i = 0; i < items.length; i += 2) {
      pairs.push(items.slice(i, i + 2));
    }

    /*
    return (
      <div className="conference-items">
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair.map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                <>
                  <a
                    className="conference-item-link"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "inherit",
                      cursor: "pointer",
                    }}
                  >
                    <div className="conference-item">
                      <div className="conference-img-large">
                        <img
                          src={`${serverConfig.serverUrl}/img/training_schools/${item.img}`}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                            backgroundColor: "transparent",
                            borderRadius: "5%",
                          }}
                        />
                        
                      </div>
                      <div className="conference-item-content">
                        <strong>{item.title}</strong>
                        <p
                          dangerouslySetInnerHTML={{ __html: item.info_school }}
                        />
                      </div>
                    </div>
                    
                  </a>
                </>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
    */

    return (
      <div className="conference-items">
        {pairs.map((pair, pairIndex) => (
          <div className="row" key={pairIndex}>
            {pair
            .sort((a,b) => a.order - b.order)
            .map((item, itemIndex) => (
              <div className="col-12 col-lg-6" key={itemIndex}>
                <a
                  className="conference-item-link"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                >
                  <div className="conference-item">
                    <div className="conference-item-title">
                      {item.title && (
                        <div>
                          <h1>{item.title}</h1>
                        </div>
                      )}
                    </div>
                    <div className="conference-item-content-details">
                      <div className="conference-img-large">
                        <img
                          src={`${serverConfig.serverUrl}/img/training_schools/${item.img}`}
                          alt={item.title}
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                            backgroundColor: "transparent",
                            borderRadius: "5%",
                          }}
                        />
                      </div>

                      <div className="conference-dates">
                        {item.start_date && (
                          <div style={{textAlign: "center"}}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-check"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "green" }}
                            >
                              <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            <strong>START</strong>:<br></br> <span>{item.start_date}</span>
                          </div>
                        )}
                        {item.end_date && (
                          <div style={{textAlign: "center"}}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-calendar2-x"
                              viewBox="0 0 16 16"
                              style={{ marginRight: "10px", color: "red" }}
                            >
                              <path d="M6.146 8.146a.5.5 0 0 1 .708 0L8 9.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 10l1.147 1.146a.5.5 0 0 1-.708.708L8 10.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 10 6.146 8.854a.5.5 0 0 1 0-.708" />
                              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
                            </svg>
                            <strong>END</strong>:<br></br> <span>{item.end_date}</span>
                          </div>
                        )}
                        {item.text && (
                          <div>
                            <span>{item.text}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  };

  const textHtml = `
    <p>
      A partire dal 2015 sono istituite <b>scuole di formazione pratico-applicative</b> nei settori degli alimenti, ambiente, farma, biofarma, clinica, imaging, metabolomica, lipidomica, tossicologia.
      </br> Queste scuole costituiscono una novità assoluta nel panorama della spettrometria di massa italiana.
    </p>
    <ul>
      <li>Il format generale prevede una durata di un giorno e mezzo suddivisi in un pomeriggio di parte teorica-applicativa e presentazione degli esperimenti e un’intera giornata in laboratorio.</li>
      <li>Il numero di studenti per ogni sessione pratica è limitato a 4-6.</li>
      <li>La selezione degli studenti avverrà tenendo conto sia della data di iscrizione che della provenienza, limitando per quanto possibile la presenza di più partecipanti da una stessa sede.</li>
    </ul>
    <p>
      Negli anni 2015-2025 sono state organizzate <b> 75 scuole </b> di formazione pratico-applicative.</br>
    </p>
  `;

  const viewTrainingSchools = (
    <>
      <div dangerouslySetInnerHTML={{ __html: textHtml }}></div>
      <div
        style={{
          border: "2px solid black",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
          margin: "10px",
          padding: "10px",
          textAlign: "center",
          fontSize: "25px",
        }}
      >
        <label style={{ marginRight: "10px" }}>
          <strong>SCUOLE DI FORMAZIONE PRATICO-APPLICATIVE PER L'ANNO </strong>
        </label>
        <DatePicker
          selected={selectedYear}
          onChange={handleYearChange}
          dateFormat="yyyy"
          showYearPicker
          placeholderText="Seleziona l'anno"
          className="custom-datapicker"
        />
      </div>
      {selectedYear.getFullYear() === 2020 &&
        content["2020"] &&
        content["2020"][1] && (
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: content["2020"][1]["info_year"],
              }}
            />
          </div>
        )}

      {/*
      {content && (
        <div>
          {Object.entries(content).map(([year, items]) => (
            <div key={year}>{renderImages(items)}</div>
          ))}
        </div>
      )}
      */}

      {content && Object.keys(content).length > 0 ? (
        <div>
          {Object.entries(content).map(([group, items]) => (
            <div key={group}>{renderImages(items)}</div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: "center", color: "red" }}>
          NON SONO PRESENTI DELLE SCUOLE DI FORMAZIONE PER L'ANNO SELEZIONATO
        </div>
      )}
    </>
  );

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {/*}
      <div className="row">
        <div className="col-12 col-lg-2">
          <SecondaryMenu vertical={true}></SecondaryMenu>
        </div>
        <div className="col-12 col-lg-10">{viewTrainingSchools}</div>
      </div>
      */}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{viewTrainingSchools}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {viewTrainingSchools}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TrainingSchools;
